import { createSlice } from "@reduxjs/toolkit";
import { eventsTopic, telemetryTopic, otaTopic } from "common/services/mqtt/Topics";

/** Async Thunks */
// export const subscribeToEvents = createAsyncThunk("mqtt/subscribeToEvents", async () => {
  
// });

/** Initial State */

const initialState = {
  eventsSubs: [],
  telemetrySubs : [],
  telemetryTopics: [],
  otaSubs : [],
  otaTopics: [],
  eventsTopics: []
};

/** Slice */

export const mqttSlice = createSlice({
  name: "mqtt",
  initialState,
  reducers: {
    addEventsSubscriptions: (state, action) => {
      state.eventsSubs.push(action.payload);
    },
    addTelemetrySubscriptions: (state, action) => {
      state.telemetrySubs.push(action.payload);
    },
    addOtaSubscriptions: (state, action) => {
      state.otaSubs.push(action.payload);
    },
    setTopicsToSubscribe: (state, action) => {
      if (action.payload.level == 2) {
        action.payload.gateways.map(gwId => {
          state.telemetryTopics.push(telemetryTopic(gwId));
          state.eventsTopics.push(eventsTopic(gwId));
        })
      } else if (action.payload.level == 0) {
        state.telemetryTopics.push(telemetryTopic("+"));
        state.otaTopics.push(otaTopic("+"));
        state.eventsTopics.push(eventsTopic("+"));
      } else if (action.payload.level == 1) {
        state.telemetryTopics.push(telemetryTopic("+", action.payload.username));
        state.otaTopics.push(otaTopic("+", action.payload.username));
        state.eventsTopics.push(eventsTopic("+", action.payload.username));
      }
    },
    addSubscription: (state, action) => {
      state.telemetryTopics = [...state.telemetryTopics, telemetryTopic(action.payload)];
      state.otaTopics = [...state.otaTopics, otaTopic(action.payload)];
      state.eventsTopics = [...state.eventsTopics, eventsTopic(action.payload)];
    },
    clearMQTTState: (state) => {
      state.telemetryTopics = [];
      state.otaTopics = [];
      state.otaSubs = [];
      state.eventsTopics = [];
      state.eventsSubs = [];
      state.telemetrySubs = [];
    }
  }
});

export const { addEventsSubscriptions, addTelemetrySubscriptions, addOtaSubscriptions, setTopicsToSubscribe, clearMQTTState, addSubscription } = mqttSlice.actions;
export default mqttSlice.reducer;